module.exports = __webpack_public_path__ + "static/media/pout-cerny-detail2.535c25dc.jpg";